export default __webpack_public_path__ + "static/media/sunstrike.16ba36d6.mpeg";